import type { Chart } from "chart.js";

const defaultFont = { size: 16, style: "normal", family: "Helvetica Neue" };

export default function drawPointLabel(chart: Chart, font: Partial<typeof defaultFont> = {}): void {
  const ctx = chart.ctx;
  const selectedFont = { ...defaultFont, ...font };

  chart.data.datasets.forEach((dataset, datasetIndex) => {
    const meta = chart.getDatasetMeta(datasetIndex);
    if (!chart.isDatasetVisible(datasetIndex)) {
      return;
    }

    meta.data.forEach((element, index) => {
      const point = (dataset.data[index] as { metadata?: Record<string, unknown> } | undefined) ?? {};
      const metadata = point.metadata ?? {};
      const dataString = metadata.label as string | undefined;
      if (!dataString) {
        return;
      }

      const position = (element as { x: number; y: number });
      const borderColor = String((dataset as { borderColor?: string }).borderColor ?? "#000");

      ctx.fillStyle = borderColor;
      ctx.font = `${selectedFont.style} ${selectedFont.size}px ${selectedFont.family}`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(dataString, position.x, position.y - selectedFont.size / 2 - 5);
    });
  });
}
